export function escapeHtml(text) {
  if (!text) return ""
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

export function formatPreviewKey(key) {
  return key
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase())
}

export function formatPreviewValue(value) {
  if (value === null || value === undefined) return "-"
  if (Array.isArray(value)) {
    return value.map((v) => escapeHtml(String(v))).join(", ") || "-"
  }
  if (typeof value === "object") {
    return `<code>${escapeHtml(JSON.stringify(value))}</code>`
  }
  if (typeof value === "boolean") {
    return value ? "✓" : "✗"
  }
  const str = String(value)
  return escapeHtml(str.length > 200 ? `${str.substring(0, 200)}...` : str)
}

export function previewDataEntries(data, limit = 12) {
  if (!data || Object.keys(data).length === 0) return []

  return Object.entries(data)
    .filter(([key]) => key !== "description")
    .slice(0, limit)
    .map(([key, value]) => ({
      key,
      label: formatPreviewKey(key),
      valueHtml: formatPreviewValue(value),
    }))
}
